export default __webpack_public_path__ + "static/media/rightArrow.4a823a4e.svg";